module.exports = __webpack_public_path__ + "img/icon-collect.83a428e7.svg";